import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ContentRepair icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ContentRepair } from '@sravni/design-system-icons'
 *
 * <ContentRepair />
 * ```
 */
var ContentRepair = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ContentRepair", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.716 7.5H4.257a1.02 1.02 0 0 1-1.02-1.02V3.52c0-.563.456-1.02 1.02-1.02h10.46c.563 0 1.02.457 1.02 1.02v2.96a1.02 1.02 0 0 1-1.021 1.02v0ZM10.736 18.333H9.07a.834.834 0 0 1-.834-.833v-4.167c0-.46.374-.833.834-.833h1.666c.46 0 .834.373.834.833V17.5c0 .46-.374.833-.834.833Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.902 12.5v-1.667c0-.46.374-.833.834-.833h6.666c.46 0 .834-.373.834-.833V5.833A.834.834 0 0 0 17.402 5h-1.666", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ContentRepair };
//# sourceMappingURL=ContentRepair.js.map
